import {createStore} from 'redux';
import Reducer from "./Reducer";

const reduxStore = createStore(Reducer);

export default reduxStore;